import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Grid, Paper } from '@material-ui/core';

class DeleteDiningLocationModal extends Component {
    render() {
        return (
            <>
                <Grid>
                    <Paper elevation={3} className="paperModalCategory" square='false' color='secondary'>
                        <Grid id='dining_location_deletetion_modal' container justify='flex-start' alignItems='baseline' style={{ height: '100%' }} >
                            {/* Title and subtitle */}
                            <Grid item container alignItems='center' className="TitleRepairsModal">Confirm Dining Location Deletion</Grid>
                            <Grid item container className="RepairsModalContainer">
                                <Grid item container justify='center' alignItems='center' className="subtitleMenuItemModal">
                                    <Grid item xs={10} md={12} lg={12} id='message_title'>
                                        Are you sure you want to delete this dining location?  
                                    </Grid>
                                </Grid>
    
                                {
                                    (this.props.location && this.props.location.count && this.props.location.count>0)?
                                    <Grid item container justify='center' alignItems='center' id='message_body' style={{fontFamily:'Gotham-Book', fontSize:'24px', color:'white', opacity:'0.56', marginBottom:'1rem'}}>
                                        <Grid item xs={10} md={12} lg={12}>
                                                            
                                            { 
                                                (this.props.location && this.props.location.count && this.props.location.count>0) && 
                                                `You currently have ${this.props.location.count} ${this.props.location.count>1?'menu items':'menu item'} listed for "${this.props.location.name}" that will be placed into “No Location”.`
                                            }
                                                    
                                        </Grid>
                                        
                                    </Grid>
                                    :
                                    undefined
                                }


                                    {/* Dining Location Info */}
                                    
                                    <Grid item container justify='center' alignItems='flex-start'>
                                    {
                                        (this.props.location) &&
                                            <Grid id={`dining_location_${this.props.location._id}`} item container className="padding5">
                                                <Grid item direction="row" spacing={0} className="menuItemBackground alingCenter">
                                                    <Grid item xs={12}>
                                                        {/* Image */}
                                                        <Grid item container className="alingCenter" 
                                                            style={{backgroundColor:'black', padding:'10px', borderTopLeftRadius:'16px', borderTopRightRadius:'16px', heigth:'250px'}}>
                  
                                                            <Grid item style={{fontFamily:'Gotham-Book', fontSize:'70px'}}>{this.props.location?.name?this.props.location.name.charAt(0).toUpperCase():''}</Grid>
                                                            
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        {/* location name */}
                                                        <Grid item container className="alingLeftName" style={{padding:'20px'}}>
                                                            {
                                                                (this.props.location?.name) ?
                                                                    this.props.location.name
                                                                    :
                                                                    'N/A'
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                    }
                                    </Grid>
                                    {/* Buttons */}
                                    <Grid item container className="ModalButtonsContainer alingCenter" justify='flex-end'>
                                        <Grid item container className="alingCenter" direction='row'>
                                            <Grid item container className="MenuItemModalButtonNo alingCenter">
                                                <Grid id='cancel_repair_return_btn' item container className="alingCenter" onClick={() => this.props.close()}>
                                                    No, Exit
                                                </Grid>
                                            </Grid>
                                            <Grid item container className="MenuItemModalButtonYes alingCenter">
                                                <Grid id='cancel_repair_cancel_btn' item container className="alingCenter" onClick={()=>this.props.onDelete()}>
                                                    Yes, Delete
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                    </Paper>
                </Grid>
            </>
        )
    }
}


function mapStateToProps(state) {
    return {

    }
};

export default connect(mapStateToProps, {})(DeleteDiningLocationModal);

